import { render } from "./TickerAbout.vue?vue&type=template&id=2d7dcafa"
import script from "./TickerAbout.vue?vue&type=script&lang=js"
export * from "./TickerAbout.vue?vue&type=script&lang=js"

import "./TickerAbout.vue?vue&type=style&index=0&id=2d7dcafa&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__